import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const TooltipContainer = styled.div`
  min-width: 244px;
  height: 44px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  span {
    font-size: 12px;
    font-weight: 400;
    color: ${colors.text['main-900']};
    line-height: 20px;
    white-space: nowrap;
  }

  span:last-child {
    margin-left: 30px;
  }
`;

export const CircleCategory = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  margin: 4px 0;
  border-radius: 9999px;
  background-color: ${({ color }) => color};
`;
